import ItemLibrary, { LibraryClickHandler } from '@/components/ItemLibrary'
import { TreeSelector } from '@/components/embeds/tree/NoteEditor'
import { CustomItemList } from '@/components/item/ItemList'
import Data, { treeNode } from '@/data'
import { ItemDefinition, UniqueDefinition } from '@/data/types'
import { itemCategories } from '@/library'
import { itemGetName } from '@/logic/item'
import Store from '@/store'
import { INSERT_MAXROLL_EMBED_COMMAND, RteDropdown } from '@maxroll-media-group/common-libs'
import classNames from 'classnames'
import { type LexicalEditor } from 'lexical'
import React from 'react'
import './EmbedToolbar.scss'

const tooltipTabs = [
  { id: 'items', name: 'Basic Items' },
  { id: 'custom', name: 'Custom Items' },
  { id: 'passives', name: 'Passives' },
  { id: 'atlas', name: 'Atlas' }
]

export function RteTooltipPopout({ activeEditor, className }: { activeEditor: LexicalEditor; className?: string }) {
  const store = Store.useStore()
  const [tab, setTab] = React.useState('items')
  const onClickItem = React.useCallback<LibraryClickHandler>(
    (e, id) => {
      const item: ItemDefinition | UniqueDefinition = Data.items[id] ?? Data.uniques[id]
      if (!item) return
      // const sel = getSelection(editor!)
      // const text = sel.text || item.name
      const text = item.name
      activeEditor.dispatchCommand(INSERT_MAXROLL_EMBED_COMMAND, {
        embedType: 'poe-item',
        id: item.hash || item.id,
        text: text
      })
    },
    [activeEditor]
  )
  const onClickCustom = React.useCallback(
    (id: number | undefined) => {
      if (id == null) return
      const storeState = store.getState()
      const item = storeState.items[id]
      if (!item) return

      //   const sel = getSelection(editor)
      const text = itemGetName(item)
      const profileId = storeState.imported?.id
      if (!profileId) return
      activeEditor.dispatchCommand(INSERT_MAXROLL_EMBED_COMMAND, {
        embedType: 'poe-item',
        id: `${id}`,
        profile: profileId,
        text: text
      })
    },
    [store, activeEditor]
  )
  const onClickTree = React.useCallback(
    (id: number, atlas: boolean) => {
      const node = treeNode(id, Data.defaultVersion, atlas)
      if (!node) return
      // const sel = getSelection(editor)
      // const text = sel.text || node.name
      const text = node.name
      activeEditor.dispatchCommand(INSERT_MAXROLL_EMBED_COMMAND, {
        embedType: `poe-${atlas ? 'atlas' : 'passive'}`,
        id: `${id}`,
        text: text
      })
    },
    [activeEditor]
  )
  return (
    <div
      onClick={(e) => e.stopPropagation()}
      className={classNames('poeplanner-wrapper poe-rte-tooltip-popout', className)}>
      <div className="poe-header">
        {tooltipTabs.map(({ id, name }) => (
          <div key={id} className={classNames('poe-tab', { 'poe-active': tab === id })} onClick={() => setTab(id)}>
            {name}
          </div>
        ))}
      </div>
      {tab === 'items' && <ItemLibrary root={itemCategories} onClick={onClickItem} hideTree uniques />}
      {tab === 'custom' && (
        <div className="poe-ItemLibrary">
          <div className="poe-ItemCategories">
            <CustomItemList onSelect={onClickCustom} noCreate />
          </div>
        </div>
      )}
      {tab === 'passives' && <TreeSelector onSelect={onClickTree} />}
      {tab === 'atlas' && <TreeSelector atlas onSelect={onClickTree} />}
    </div>
  )
}

export function EmbedToolbar({ isEditable, activeEditor }: { isEditable?: boolean; activeEditor: LexicalEditor }) {
  return (
    <RteDropdown
      disabled={!isEditable}
      buttonClassName="toolbar-item spaced"
      buttonLabel="Tooltips"
      buttonAriaLabel="Ads selection"
      stopCloseOnClickSelf={true}>
      <RteTooltipPopout activeEditor={activeEditor} />
    </RteDropdown>
  )
}
